import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "base-table" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = {
  key: 0,
  class: "actions"
}
const _hoisted_5 = {
  key: 0,
  class: "infos"
}
const _hoisted_6 = { class: "total" }
const _hoisted_7 = { class: "pages" }
const _hoisted_8 = { class: "box-table" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["colspan"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "td-options"
}
const _hoisted_15 = { class: "options" }
const _hoisted_16 = {
  key: 0,
  class: "icon",
  title: "Visualizar"
}
const _hoisted_17 = {
  key: 1,
  class: "icon",
  title: "Copiar"
}
const _hoisted_18 = {
  key: 2,
  class: "icon",
  title: "Editar"
}
const _hoisted_19 = {
  key: 3,
  class: "icon",
  title: "Excluir"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["colspan"]
const _hoisted_22 = {
  key: 1,
  class: "pagination"
}
const _hoisted_23 = { class: "arrows" }
const _hoisted_24 = { class: "arrow" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "arrow" }

import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import trim from "lodash-es/trim";
import get from "lodash-es/get";

import { baseInput, baseLoading, svgIcon } from "@/common/components";

export interface TableHeaderType {
  key: string;
  label: string | null;
  align?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'base-table',
  props: {
    header: {},
    data: {},
    page: { default: 0 },
    pages: { default: 0 },
    limit: { default: 10 },
    total: { default: 0 },
    searched: { default: 0 },
    options: { type: Boolean, default: false },
    loading: { type: Boolean },
    view: { type: Boolean, default: false },
    copy: { type: Boolean, default: false },
    edit: { type: Boolean, default: false },
    del: { type: Boolean, default: false },
    paginated: { type: Boolean, default: true },
    add: { type: Boolean, default: true },
    upload: { type: Boolean, default: false },
    showSearch: { type: Boolean, default: true }
  },
  emits: [
  "searching",
  "btn:add",
  "btn:view",
  "btn:upload",
  "btn:copy",
  "btn:edit",
  "btn:del",
  "change:page",
],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const props = __props;

const emit = __emit;

const search = ref("");

const totalSearch = computed(() => {
  const { limit, page, searched, total } = props;
  const sum = (page + 1) * limit;
  if (page > 0) return sum < total ? sum : total;

  return searched;
});

function searchValue() {
  if (trim(search.value).length === 0) return;

  emit("searching", search.value);
}

function changePage(event: any) {
  const value = event?.target?.value || 0;
  const sanitize = String(value)?.replace(/\D/g, "");

  if (trim(sanitize) === "") {
    emit("change:page", 0);
    return;
  }

  if (parseInt(sanitize) < 0) {
    emit("change:page", 0);
    return;
  }

  if (parseInt(sanitize) >= props.pages) {
    emit("change:page", props.pages);
    return;
  }

  emit("change:page", parseInt(sanitize) - 1);
}

function nextPage() {
  const { page, pages } = props;

  if (page + 1 >= pages) return;

  emit("change:page", page + 1);
}

function beforePage() {
  const { page } = props;

  if (page <= 0) return;

  emit("change:page", page - 1);
}

function btnView(option: any) {
  emit("btn:view", option);
}

function btnCopy(option: any) {
  emit("btn:copy", option);
}

function btnEdit(option: any) {
  emit("btn:edit", option);
}

function btnDel(option: any) {
  emit("btn:del", option);
}

watch(
  () => search.value,
  () => {
    if (trim(search.value).length === 0) emit("searching", search.value);
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "header",
      style: _normalizeStyle({
        gridTemplateColumns: __props.add || __props.upload ? '2fr auto' : '1fr',
      })
    }, [
      _createElementVNode("div", _hoisted_2, [
        (__props.showSearch)
          ? (_openBlock(), _createBlock(_unref(baseInput), {
              key: 0,
              modelValue: search.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
              background: "#fff",
              color: "#000",
              placeholder: _unref(t)('common.labels.search'),
              "onKey:enter": _cache[2] || (_cache[2] = ($event: any) => (searchValue()))
            }, {
              sufix: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(svgIcon), {
                    icon: "search",
                    size: "1.75rem",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (searchValue()))
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"]))
          : _createCommentVNode("", true)
      ]),
      (__props.add || __props.upload)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (__props.upload)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-md btn-primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('btn:upload')))
                }, [
                  _createVNode(_unref(svgIcon), {
                    icon: "upload",
                    size: "1.5rem"
                  }),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("common.labels.upload")?.toUpperCase()), 1)
                ]))
              : _createCommentVNode("", true),
            (__props.add)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-md btn-primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('btn:add')))
                }, [
                  _createVNode(_unref(svgIcon), {
                    icon: "add",
                    size: "1.5rem"
                  }),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("common.labels.add")?.toUpperCase()), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 4),
    (__props.paginated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.showing")) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(totalSearch.value), 1),
            _cache[8] || (_cache[8] = _createTextVNode(" - ", -1)),
            _createElementVNode("strong", null, _toDisplayString(__props.total || 0), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.page")) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(__props.page + 1), 1),
            _cache[9] || (_cache[9] = _createTextVNode(" - ", -1)),
            _createElementVNode("strong", null, _toDisplayString(__props.pages), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("table", null, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.header, (item) => {
              return (_openBlock(), _createElementBlock("th", {
                key: item.key,
                style: _normalizeStyle({ 'text-align': item.align ? item.align : 'start' })
              }, _toDisplayString(item.label), 5))
            }), 128)),
            (__props.options)
              ? (_openBlock(), _createElementBlock("th", _hoisted_9))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (__props.loading)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                _createElementVNode("td", {
                  colspan: ((__props.header || []).length || 1) + (__props.options ? 1 : 0)
                }, [
                  _createVNode(_unref(baseLoading))
                ], 8, _hoisted_11)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.header, (head) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: head.key
                      }, [
                        (!_ctx.$slots[head.key])
                          ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(_unref(get)(item, head.key, "")), 1))
                          : (_openBlock(), _createElementBlock("td", _hoisted_13, [
                              _renderSlot(_ctx.$slots, head.key, { data: item })
                            ]))
                      ], 64))
                    }), 128)),
                    (__props.options)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            (__props.view)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createVNode(_unref(svgIcon), {
                                    icon: "eye",
                                    size: "1.75rem",
                                    onClick: ($event: any) => (btnView(item))
                                  }, null, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true),
                            (__props.copy)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createVNode(_unref(svgIcon), {
                                    icon: "copy",
                                    size: "1.75rem",
                                    onClick: ($event: any) => (btnCopy(item))
                                  }, null, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true),
                            (__props.edit)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createVNode(_unref(svgIcon), {
                                    icon: "edit",
                                    size: "1.75rem",
                                    onClick: ($event: any) => (btnEdit(item))
                                  }, null, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true),
                            (__props.del)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createVNode(_unref(svgIcon), {
                                    icon: "trash",
                                    size: "1.75rem",
                                    onClick: ($event: any) => (btnDel(item))
                                  }, null, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                ((__props.data || []).length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                      _createElementVNode("td", {
                        class: "empty",
                        colspan: ((__props.header || []).length || 1) + (__props.options ? 1 : 0)
                      }, _toDisplayString(_unref(t)("common.texts.no_results")), 9, _hoisted_21)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ])
    ]),
    (__props.paginated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_unref(svgIcon), {
                icon: "arrow-left",
                size: "1.15rem",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (beforePage()))
              })
            ]),
            _createElementVNode("input", {
              name: "page",
              value: __props.page + 1,
              onChange: _cache[6] || (_cache[6] = ($event: any) => (changePage($event)))
            }, null, 40, _hoisted_25),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_unref(svgIcon), {
                icon: "arrow-right",
                size: "1.15rem",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (nextPage()))
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})